var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trello-column-header"},[_c('span',{staticClass:"trello-column-header__title"},[_vm._v(_vm._s(_vm.text)+" "+_vm._s(_vm.length))])])}
var staticRenderFns = []

export { render, staticRenderFns }